import { TrainingRequirement } from "./training-requirement";

export class CreateTrainingRequirementRequest {
    trainingRequirement!: TrainingRequirement;
    users!: string[];
}
